<template>
<div>
  <el-table :data="list">
    <el-table-column label="时间">
      <template slot-scope="scope">
        <span>{{scope.row.businessTime | moment}}</span>
      </template>
    </el-table-column>
    <el-table-column prop="fromUserId" label="转出账号">
    </el-table-column>
    <el-table-column prop="toUserId" label="转入账号">
    </el-table-column>
    <el-table-column prop="coinType" label="币种">
    </el-table-column>
     <el-table-column prop="transferAmount" label="数量">
    </el-table-column>
     <el-table-column prop="totalAmount" label="转入后金额">
    </el-table-column>
    <el-table-column label="更新时间">
      <template slot-scope="scope">
        <span>{{scope.row.updateTime | moment}}</span>
      </template>
    </el-table-column>
  </el-table>
  <pagination :size="pagination.size" :page="pagination.page" :total="totalCount" @pageChanged="handleCurrentChange">
  </pagination>
</div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import Pagination from 'components/pagination';

export default {
  name: 'transferInnerList',
  computed: {
    ...mapState('transferInner', ['totalCount', 'pagination']),
    ...mapGetters('transferInner', ['list'])
  },
  components: {
    Pagination
  },
  methods: {
    ...mapActions('transferInner', ['remove']),
    ...mapMutations('transferInner', ['setDetail']),
    handleCurrentChange(pagination) {
      this.$emit('refresh', pagination);
    },
    viewDetail(item) {
      this.setDetail(item);
    },
    removeItem(row) {
      this.$confirm('确认要删除么？', '提示', {
        type: 'warning'
      }).then(() => {
        this.remove(row.id).then(() => {
          this.$message({
            message: '删除成功！',
            type: 'success'
          });
          this.$emit('refresh', { page: 1 });
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
</style>
